import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiArrowUpRight, FiClock } = FiIcons;
const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const sessions = [
  { time: '06:30', name: 'Rise & lift', type: 'STRENGTH', coach: 'Alex M.', length: '45 MIN' },
  { time: '08:00', name: 'Engine room', type: 'CONDITIONING', coach: 'Sam R.', length: '50 MIN' },
  { time: '12:15', name: 'Move better', type: 'MOBILITY', coach: 'Jordan L.', length: '40 MIN' },
  { time: '17:30', name: 'Strong basics', type: 'STRENGTH', coach: 'Alex M.', length: '50 MIN' },
  { time: '19:00', name: 'Afterburn', type: 'HIIT', coach: 'Sam R.', length: '45 MIN' },
];

function Schedule({ activeDay, onDayChange }) {
  return (
    <section className="schedule-section" id="schedule">
      <div className="section-head">
        <div>
          <span className="eyebrow">Make a little time for you</span>
          <h2>Your week,<br /><em>well spent.</em></h2>
        </div>
        <a className="text-link" href={waLink('I would like to see the full class schedule.')} target="_blank" rel="noreferrer">
          See all classes <SafeIcon icon={FiArrowUpRight} />
        </a>
      </div>
      <div className="schedule-board">
        <div className="schedule-days" role="tablist" aria-label="Choose a day">
          {days.map((day) => (
            <button
              key={day}
              type="button"
              role="tab"
              aria-selected={activeDay === day}
              className={activeDay === day ? 'day-tab active' : 'day-tab'}
              onClick={() => onDayChange(day)}
            >
              {day}<span>{day === 'MON' ? '12' : day === 'TUE' ? '13' : day === 'WED' ? '14' : day === 'THU' ? '15' : day === 'FRI' ? '16' : '17'}</span>
            </button>
          ))}
        </div>
        <div className="session-list" role="tabpanel">
          {sessions.map((session) => (
            <a className="session-row" key={session.time} href={waLink(`I want to book the ${session.name} class on ${activeDay}.`)} target="_blank" rel="noreferrer">
              <div className="session-time"><SafeIcon icon={FiClock} />{session.time}</div>
              <div className="session-name"><h3>{session.name}</h3><span>{session.type}</span></div>
              <span className="session-coach">{session.coach}</span>
              <span className="session-length">{session.length}</span>
              <span className="session-arrow"><SafeIcon icon={FiArrowUpRight} /></span>
            </a>
          ))}
        </div>
        <p className="schedule-note">Showing classes for {activeDay.toLowerCase()}. Class times may vary by week.</p>
      </div>
    </section>
  );
}
export default Schedule;
